import { MakeModelIndex } from './make-model-index.service';
import { BrandWithCounts } from './mappers';
import { AlgoliaFacets } from './types';

export function mergeMakeModelCounts(
  index: MakeModelIndex[],
  facets: AlgoliaFacets,
): BrandWithCounts[] {
  const brandCounts =
    (facets?.['brand_id.name'] as Record<string, number>) ?? {};

  const rangeCounts =
    (facets?.['range_id.name'] as Record<string, number>) ?? {};

  return index.map((brand) => {
    const brandVehicleCount =
      brandCounts[brand.name] ?? 0;

    const ranges = brand.range_ids.map((range) => ({
      id: range.id,
      name: range.name,
      vehicleCount:
        rangeCounts[range.name] ?? 0,

      models: (range.models ?? []).map((model) => ({
        id: model.id,
        name: model.name,
        vehicleCount: model.count ?? 0,
      })),
    }));

    return {
      id: brand.id,
      name: brand.name,
      vehicleCount: brandVehicleCount,
      range_ids: ranges,
    };
  });
}
